import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { updateItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import DeliveryOrder from "../../models/delivery-order";

interface DeliveryOrderRevertModalProps {
  show: boolean;
  deliveryOrder?: DeliveryOrder;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const DeliveryOrderRevertModal: React.FC<DeliveryOrderRevertModalProps> = ({
  show,
  deliveryOrder,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = deliveryOrder
    ? `Está seguro de que quiere revertir/anular el envío #${deliveryOrder.id}, ${deliveryOrder.clientName}`
    : "";

  const onSubmitClick = async () => {
    if (deliveryOrder !== undefined) {
      setSubmitting(true);

      let toSendDeliveryOrder: DeliveryOrder = {
        ...deliveryOrder,
      };
      const orderStatus = await updateItem<DeliveryOrder>(
        `/delivery_orders/${deliveryOrder.id}/revert/`,
        toSendDeliveryOrder
      );

      if (orderStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (orderStatus.errors !== undefined) {
        }
        if (orderStatus.detail !== undefined) {
          message = orderStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-warning" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Revertir/anular Envío</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
              <p>
                {" "}
                Al revertir/anular las cantidades seleccionadas se devolveran a
                los inventarios originales.
              </p>
              <p>
                {" "}
                La deuda generada al cliente por este envío tambien disminuirá.
              </p>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onSubmitClick} color="warning">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Revirtiendo..." : "Revertir"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default DeliveryOrderRevertModal;
